import { LinkedContact } from "@/Common/Api/Patient/Dto/LinkedContact";
import { NameHelper, NameHelperFormat } from "@/Common/Helpers/NameHelper";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";

class Representant {
    private Representant: LinkedContact;

    constructor(representant: LinkedContact) {
        this.Representant = representant;
    }

    public get fullName(): string {
        return NameHelper.formatFullNameForHasName(this.Representant.Individual, NameHelperFormat.FirstNameFirst);
    }

    public get firstName(): string {
        return this.Representant.Individual.FirstName;
    }

    public get lastName(): string {
        return this.Representant.Individual.LastName;
    }

    public get hasValidEmail(): boolean {
        return this.Representant.Emails.any(email => ValidationHelper.isExactMatch(email.Address, ValidationHelper.emailRegex));
    }

    public get contactId(): string {
        return this.Representant.Individual.Contact_id;
    }
}

export { Representant };
